/*
 * @Author: zloongjiang
 * @Date:   2021-06-20 14:35:03
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-06-21 20:30:09
 */
import _ from 'lodash';
import querystring from 'query-string';
import { post } from '../../fetchers/fetch';
import { isomorphicConfig } from '../../utility/';
import { reportBaseData } from '../../utility/kdReport/baseData';
import qblogin from '@tencent/qblogin';
const host = _.get(isomorphicConfig, 'kdStatHost');

/**
 * DeviceInfo 设备公参
 * @param  {Number}  options.app_type     1:QB
 * @param  {String}  options.app_version
 * @param  {Number}  options.os           0:unknow 1:Android 2: IOS
 * @param  {Number}  options.network      0:unknow 1:wifi 2~5:2~5g
 * @param  {String}  options.device_id    设备id (IOS填IDFV，安卓填IMSI)
 * @param  {String}  options.ip
 * @param  {String}  options.qua
 * @param  {String}  options.guid
 * @param  {String}  options.terminal_id
 * @param  {String}  options.terminal_type
 * @param  {Number}  options.wangka       0-非王卡 1-王卡
 * @param  {String}  options.manufacturer 设备制造商，如 meizu，xiaomi
 * @param  {String}  options.device_brand_and_model 设备的品牌和型号，如p30
 * @param  {String}  options.qimei
 * @param  {Object}  options.ext
 * @return {Promise}
 */
export const kdDeviceInfo = async () => {
  const {
    appVersion = '',
    os = 0,
    network_type: network = 0,
    ifv_id: idfv = '',
    imsi = '',
    qua = '',
    guid = '',
    imei = '',
    qimei = '',
  } = (await reportBaseData().catch(() => {})) || {};
  return {
    app_type: 1,
    app_version: appVersion,
    os,
    network,
    device_id: os === 2 ? idfv : imsi,
    ip: '',
    qua,
    guid,
    terminal_id: imei, // imei
    terminal_type: `${os ? os + 1 : 1}`, //
    wangka: 0,
    manufacturer: '',
    device_brand_and_model: '',
    qimei,
  };
};

/**
 * EnvInfo 环境公参
 * @param  {String}  options.channel      请求渠道
 * @param  {String}  options.trace_id     天机阁的追踪id
 * @param  {Boolean} options.is_preload   是否为预加载
 * @param  {String}  options.gps          用户经纬度(格式 := 经度,维度)
 * @param  {Object.ReqAdvertisePara}  options.req_advertise_para    看点侧广告请求信息
 * @return {Promise}
 */
export const kdEnvInfo = async () => {
  return {
    channel: '',
    trace_id: '',
    is_preload: false,
    gps: '',
    req_advertise_para: {},
  };
};

/**
 * 64eReportInfo 64e公参
 * @param  {Number}  options.uint64_uin      请求渠道
 * @param  {Object}  options.enum_operation  用户操作
 * @param  {Object}  options.enum_op_source  操作来源
 * @param  {Number}  options.bytes_inner_id  InnerUniqueID，内容中心唯一标识
 * @param  {Number}  options.uint32_algorithm_id  算法 1 - A1 , 2 - A2 , 3 - T
 * @param  {Number}  options.uint32_channel_id  频道
 * @param  {Number}  options.enum_network_type
 * @param  {Number}  options.operator_platform
 * @param  {Number}  options.uint32_read_time_length    阅读时长
 * @param  {Number}  options.uint32_report_time    ？上报当前时间戳
 * @param  {Number}  options.uint32_play_time_length    播放时长
 * @param  {Number}  options.uint32_video_duration      视频时长
 * @param  {Number}  options.uint32_read_article_length 文章阅读长度
 * @param  {Number}  options.uint32_article_length      文章总长度
 * @return {Promise}
 */
export const kd64eReportInfo = async () => {
  const { os, network_type } = (await reportBaseData().catch(() => {})) || {};
  /* eslint-disable */
  let uint32_algorithm_id = 0, uint32_channel_id = 0;
  try { // 避免json parse解析报错
    const { report_info = '' } = querystring.parseUrl(location.href).query || {}; // 推荐通过url下发
    const reportInfoObj = (report_info && JSON.parse(report_info) || {});
    uint32_algorithm_id = reportInfoObj.uint32_algorithm_id;
    uint32_channel_id = reportInfoObj.uint32_channel_id;
  } catch (e) { /*ignore*/ }
  return {
    uint64_uin: 0,
    enum_operation: 0,
    enum_op_source: 12,
    bytes_inner_id: 0,
    uint32_algorithm_id,
    uint32_channel_id,
    enum_network_type: network_type,
    operator_platform: os,
    uint32_read_time_length: 0,
    uint32_report_time: Date.now(),
    uint32_play_time_length: 0,
    uint32_video_duration: 0,
    uint32_read_article_length: 0,
    uint32_article_length: 0,
  };
};

export const kd46fReportInfo = async () => {
  return {
    uint64_articleid: 0,
    uint32_reasonid: 1,
    bytes_rowkey: '',
    rpt_uint64_tagid: [],
    rpt_user_dislike_list: [],
    uint64_feeds_id: 0,
    uint64_biu_uin: 0,
    rpt_tag_name: [],
    uint64_topic_id: 0,
  }
}

/**
 * 上报 大T
 * @param  {DeviceInfo}  options.device
 * @param  {EnvInfo}     options.env
 * @param  {ReportInfo}  options.msg_report_info
 * @return {Promise}
 */

export const kdReportT = async (logData = {}) => {
  const deviceInfo = await kdDeviceInfo();
  const envInfo = await kdEnvInfo();
  const logParams = {
    ...logData,
  };
  post(`${host}/ReportT`, {
    body: JSON.stringify({
      msg_report_info: [logParams],
      deviceInfo,
      envInfo,
    }),
  });
};

/**
 * 上报 64e
 * @param  {DeviceInfo}  options.device
 * @param  {EnvInfo}     options.env
 * @param  {Object}      options.req.rpt_report_info          // ReportInfo
 * @param  {Number}      options.req.bytes_pre_load_req_info  是否预加载
 * @param  {Number}      options.req.uint64_report_uin        uin
 * @param  {Number}      options.req.uint32_report_time       上报time
 * @param  {Object}      options.req.msg_login_sig            登录态
 * @return {Promise}
 */
export const kdReport64e = async (logData = {}) => {
  const device = await kdDeviceInfo();
  const envInfo = await kdEnvInfo();
  const userInfo = await qblogin.getSession();
  const user = {
    appid_info: {
      appid: userInfo.appid,
      openid: userInfo.uin,
      token: userInfo.token,
      qbid: userInfo.qbid,
    },
  };
  const info = Object.assign((await kd64eReportInfo()) || {}, logData);
  post(`${host}/Report64e`, {
    conType: 'application/json; charset=utf-8',
    body: JSON.stringify({
      req: {
        rpt_report_info: [info],
        bytes_pre_load_req_info: '', // TODO 预加载请求信息
        uint64_report_uin: info.uint64_uin || 0,
        uint32_report_time: parseInt(Date.now() / 1000, 10),
        msg_login_sig: {}, // 登录态
        uint32_app_source: 2,
      },
      device,
      envInfo,
      user,
    }),
  });
};

export const kdReport46f = async (logData = {}) => {
  const device = await kdDeviceInfo();
  const env = await kdEnvInfo();
  const userInfo = await qblogin.getSession();
  const user = {
    appid_info: {
      appid: userInfo.appid,
      openid: userInfo.uin,
      token: userInfo.token,
      qbid: userInfo.qbid,
    },
  };
  const info = Object.assign((await kd46fReportInfo()) || {}, logData);
  post(`${host}/Report46f`, {
    conType: 'application/json; charset=utf-8',
    body: JSON.stringify({
      req: {
        rpt_param_list: [info],
        uint64_uin: logData.uint64_biu_uin,
      },
      device,
      env,
      user,
    }),
  });
}
